
const parseCookies = () => (
	document.cookie
		.split(";")
		.map( item => item.trim())
		.filter( Boolean )
		.map( item => {
			const separator_index = item.indexOf("=");

			return separator_index === -1
				? { key: item, value: "" }
				: { key: item.slice( 0, separator_index ), value: item.slice( separator_index + 1 )};
		})
);


const Cookie = {

	setCookie: ( key, value, max_age_seconds ) => {
		let cookie_str = `${ key }=${ encodeURIComponent( value )}; path=/; SameSite=Lax`;
		if ( max_age_seconds !== undefined ) cookie_str += `; max-age=${ max_age_seconds }`;

		document.cookie = cookie_str;
	},

	getCookie: key => {
		const cookie = parseCookies().find( item => item.key === key );
		if ( !cookie ) return null;

		// A value with a broken percent-encoding cannot be read, so it is treated as missing
		try {
			return decodeURIComponent( cookie.value );
		} catch ( error ) {
			return null;
		}
	},

	removeCookie: ( key, domain ) => {
		let cookie_str = `${ key }=; path=/; max-age=0`;
		if ( domain ) cookie_str += `; domain=${ domain }`;

		document.cookie = cookie_str;
	},

	getAllCookieKeys: () => parseCookies().map( item => item.key )
}


export default Cookie;
